// extracted by mini-css-extract-plugin
export default {"linkText":"linkText--08acfd99"};